import {
  DebouncedTextInput,
  Group,
  GroupItem,
  GroupTitle,
  ReferenceAutocompleteInput,
  useSaveMutation,
} from "ra-friendsofbabba";
import { SimpleForm, required, useRedirect, useTranslate } from "react-admin";

import { ACCEPTED_FILE_TYPES } from "../config";
import DocFileTypeInput from "./input/DocFileTypeInput";
import DocFileTypeOtherInput from "./input/DocFileTypeOtherInput";
import { MediaInput } from "../component/input";
import React from "react";
import UserFilteredInput from "./input/UserFilteredInput";

const Form = (props) => {
  const translate = useTranslate();
  const redirect = useRedirect();
  const save = useSaveMutation({
    ...props,
    onSuccess: () => redirect("list", props.basePath),
  });
  return (
    <SimpleForm {...props} save={save}>
      <Group wrapper fullWidth>
        <GroupTitle
          title={translate("resources.doc-files.title")}
          subTitle={translate("resources.doc-files.helper")}
        />
        <Group>
          <GroupItem lg={12} md={12} sm={12}>
            <ReferenceAutocompleteInput
              source="research_project_id"
              reference="research-projects"
              optionText="full_title"
              validate={required()}
            />
          </GroupItem>
        </Group>
        <Group>
          <GroupItem lg={12} md={12} sm={12}>
            <UserFilteredInput source="user_id" />
          </GroupItem>
        </Group>
        <Group>
          <GroupItem lg={6} md={6} sm={12}>
            <DocFileTypeInput source="doc_file_type_id" validate={required()} />
          </GroupItem>
          <GroupItem lg={6} md={6} sm={12}>
            <DocFileTypeOtherInput
              source="doc_file_type_other"
              validate={required()}
            />
          </GroupItem>
        </Group>
        <Group>
          <GroupItem lg={12} md={12} sm={12}>
            <DebouncedTextInput
              source="description"
              maxLength={4000}
              multiline
              validate={required()}
            />
          </GroupItem>
        </Group>
        <Group>
          <GroupItem lg={12} md={12} sm={12}>
            <MediaInput
              source="media"
              acceptedFormats={[ACCEPTED_FILE_TYPES + ",.eml"]}
              validate={required()}
            />
          </GroupItem>
        </Group>
      </Group>
    </SimpleForm>
  );
};
export default Form;
